import React, { memo } from "react";
import { Handle, Position } from "reactflow";
import type { NodeProps } from "reactflow";
import "../../styles/components/CustomNode.css";

interface CustomNodeProps extends NodeProps {
  data: any;
}

const CustomNode: React.FC<CustomNodeProps> = ({ data, selected }) => {
  const categoryClass = data.category || "trigger";

  return (
    <div
      className={`custom-node node-${categoryClass} ${
        selected ? "selected" : ""
      }`}>
      <Handle type="target" position={Position.Left} className="node-handle" />

      <div className="node-header">
        <div className="node-header-icon">{data.icon || "📦"}</div>
        <div className="node-header-title">{data.label || "Node"}</div>
      </div>

      <div className="node-body">
        {data.nodeKey && (
          <div className="node-field">
            <div className="node-field-label">Type:</div>
            <div className="node-field-value">{data.nodeKey}</div>
          </div>
        )}
        {data.config && Object.keys(data.config).length > 0 && (
          <>
            {Object.entries(data.config)
              .slice(0, 2)
              .map(([key, value]) => (
                <div key={key} className="node-field">
                  <div className="node-field-label">{key}:</div>
                  <div className="node-field-value">
                    {String(value).substring(0, 20)}
                    {String(value).length > 20 ? "..." : ""}
                  </div>
                </div>
              ))}
          </>
        )}
      </div>

      <Handle type="source" position={Position.Right} className="node-handle" />
    </div>
  );
};

export default memo(CustomNode);
